(function() {
  'use strict';

  // Off-canvas drawer behaviour for the mobile menu. Works WITH the
  // theme's legacy jQuery code rather than editing it: a capture-phase
  // listener on document claims the burger's click before the jQuery
  // slideToggle handler on the button can run, and the drawer is driven
  // by the classes in mobile-nav-drawer.css. The submenu accordion inside
  // the nav stays the theme's own jQuery slideDown/Up, untouched.

  // 1023, not 749, since 2026-09-12: the phone header - burger included -
  // now runs up to the desktop bar at 1024 (assets/bc-responsive.css, 2).
  var mq = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : null;
  var nav = null;
  var overlay = null;
  var isOpen = false;
  var savedY = 0;
  var touchStartX = null;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function onMobile() {
    return !mq || mq.matches;
  }

  function setDrawer(next, focusTarget) {
    if (!nav || next === isOpen) return;
    isOpen = next;

    document.documentElement.classList.toggle('bc-drawer-open', isOpen);

    var burger = document.getElementById('ToggleMobileMenu');
    if (burger) {
      burger.classList.toggle('open', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
    nav.setAttribute('aria-hidden', isOpen ? 'false' : (onMobile() ? 'true' : 'false'));

    if (isOpen) {
      // Freeze the page without the jump: fix the body at its current
      // scroll offset, and give the offset back on close.
      savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -savedY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      var closeBtn = nav.querySelector('.bc-drawer-close');
      if (closeBtn && closeBtn.focus) closeBtn.focus({ preventScroll: true });
    } else {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedY);
      if (focusTarget && focusTarget.focus) focusTarget.focus({ preventScroll: true });
    }
  }

  ready(function() {
    nav = document.getElementById('SiteNav');
    if (!nav || nav.dataset.bcDrawerReady === 'true') return;
    nav.dataset.bcDrawerReady = 'true';

    var head = document.createElement('div');
    head.className = 'bc-drawer-head';
    head.innerHTML = ''
      + '<span class="bc-drawer-head__title">Menu</span>'
      + '<button type="button" class="bc-drawer-close" aria-label="Close menu">'
      + '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>'
      + '</button>';
    nav.insertBefore(head, nav.firstChild);

    overlay = document.createElement('div');
    overlay.className = 'bc-drawer-overlay';
    document.body.appendChild(overlay);

    if (onMobile()) nav.setAttribute('aria-hidden', 'true');

    // The burger. Capture phase on document runs before any handler bound
    // on the button itself, so preventDefault + stopPropagation here is
    // what keeps the theme's slideToggle from ever firing on phones.
    document.addEventListener('click', function(event) {
      var burger = event.target && event.target.closest ? event.target.closest('#ToggleMobileMenu') : null;
      if (!burger || !onMobile()) return;
      event.preventDefault();
      event.stopPropagation();
      setDrawer(!isOpen, burger);
    }, true);

    overlay.addEventListener('click', function() { setDrawer(false); });
    head.querySelector('.bc-drawer-close').addEventListener('click', function() {
      setDrawer(false, document.getElementById('ToggleMobileMenu'));
    });

    // Following a real link closes the drawer; the +/- accordion triggers
    // are <button>s and never match here.
    nav.addEventListener('click', function(event) {
      if (!isOpen || !onMobile()) return;
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href === '' || href.charAt(0) === '#') return;
      setDrawer(false);
    });

    document.addEventListener('keydown', function(event) {
      if (!isOpen) return;
      if (event.key === 'Escape' || event.key === 'Esc') {
        setDrawer(false, document.getElementById('ToggleMobileMenu'));
        return;
      }
      if (event.key !== 'Tab') return;
      // Focus trap: Tab cycles inside the panel while it is open.
      var focusables = nav.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // Swipe the panel left to close.
    nav.addEventListener('touchstart', function(event) {
      touchStartX = event.touches && event.touches.length === 1 ? event.touches[0].clientX : null;
    }, { passive: true });
    nav.addEventListener('touchend', function(event) {
      if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
      var delta = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (delta < -60) setDrawer(false);
    }, { passive: true });

    // Crossing up to tablet/desktop while open: hand the page back.
    var onChange = function() {
      if (!onMobile() && isOpen) setDrawer(false);
      if (!isOpen) nav.setAttribute('aria-hidden', onMobile() ? 'true' : 'false');
    };
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  });
})();
